import { FCX } from '@datassential/platform-ui-lib';
import Scrollbar from 'react-scrollbars-custom';

export const InstantChartsColumnBody: FCX<{ animate?: boolean }> = ({ children }) => (
    <div className="InstantCharts__column-body">
        <Scrollbar style={{ height: '100%' }}>
            <div className="InstantCharts__column-body-list">
                {children}
            </div>
        </Scrollbar>
    </div>
);
